import dashboardConfig from "./config/dashboard";
import profileConfig from "./config/profile";
import mspUserManagementConfig from "./config/enterprises";
import orgUserManagementConfig from "./config/organizations";
import onPremOrgUserManagementConfig from "./config/onPremOrganization";
import topologiesConfig from "./config/topologies";
import devicesConfig from "./config/devices";
import eventsConfig from "./config/events";
import addDevice from "./config/addDevice";
import meConfig from "./config/me";
import scopeLevelConfig from "./config/scopeLevel";
import settingConfig from "./config/scopeSetting";
import wirelessConfig from "./config/wireless";
import wiredConfig from "./config/wired";
import captivePortalConfig from './config/captivePortal';
import profilesConfig from "./config/profiles";
import settingsGeneralConfig from "./config/settingsGeneral";
import firmwareManagementsConfig from "./config/firmwareManagements";
import settingNotificationsConfig from "./config/settingNotifications";
import clientsConfig from "./config/clients";
import supportConfig from "./config/support";
import ainsightConfig from "./config/ainsight";
import licenseConfig from "./config/license";

const apiConfig = {
  ...dashboardConfig,
  ...profileConfig,
  ...mspUserManagementConfig,
  ...orgUserManagementConfig,
  ...onPremOrgUserManagementConfig,
  ...topologiesConfig,
  ...devicesConfig,
  ...eventsConfig,
  ...addDevice,
  ...meConfig,
  ...scopeLevelConfig,
  ...settingConfig,
  ...wirelessConfig,
  ...wiredConfig,
  ...captivePortalConfig,
  ...profilesConfig,
  ...settingsGeneralConfig,
  ...firmwareManagementsConfig,
  ...settingNotificationsConfig,
  ...clientsConfig,
  ...supportConfig,
  ...ainsightConfig,
  ...licenseConfig,
};

export default apiConfig;
